import React from 'react';

import ContentLoader from 'components/utility/ContentLoader/ContentLoader';

const GlossaryLoader: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <ContentLoader
      width={300}
      height={168}
      viewBox="0 0 300 168"
      className={className}
    >
      <rect width="60" height="10" x="0" y="0" />
      <rect width="200" height="40" x="0" y="23" />
      <rect width="300" height="75" x="0" y="93" />
    </ContentLoader>
  );
};

export default GlossaryLoader;
